import React, { useEffect, useState, useContext, useCallback } from "react";
import DashboardSkeleton from "./DashboardSkeleton";
import css from "./dashboard_new.module.scss";
import Carosal from "re_redesigned_componnents/carosal/Carosal";
import InfoCard from "../../re_redesigned_componnents/card/InfoCard";
import {
  IconAssessmentScore,
  IconCompletion,
  IconLogout,
  IconOpenCourse,
  IconPleCredit,
  IconMail,
  IconSetting,
  IconBell,
  IconMorning,
  IconAfternoon,
  IconEvening,
} from "re_redesigned_componnents/icon";
import * as config from "../../config";
import TabWrap from "../../re_redesigned_componnents/tab/TabWrap";
import CourseCard from "../../re_redesigned_componnents/card/CourseCard";
import AssessmentCard from "re_redesigned_componnents/card/AssessmentCard";
import PermanentDrawerWrapper from "re_redesigned_componnents/drawer/PermanentDrawerWrapper";
import SideMenu from "re_redesigned_componnents/side_menu/SideMenu";
import CircularProgressBar from "re_redesigned_componnents/circular_progressBar/CircularProgressBar";
import Dp from "../../re_redesigned_componnents/asset/profile.webp";
import Chip from "@mui/material/Chip";
import AreaChart from "re_redesigned_componnents/Graph/AreaChart";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import Custom_Carosal from "re_redesigned_componnents/carosal/Custom_Carosal";
import Header from "re_redesigned_componnents/header/Header";
import { withUserContext, withApiContext, withLabelsContext } from "context";
import { useHistory } from "react-router-dom";
import { useDirectChatModal } from "re_designed_pages/DirectChat/DirectChatModalProvider";
import Badge from "@mui/material/Badge";
import LogoutButton from "../../re_redesigned_componnents/logout/Logout";
import { useMediaQuery } from "@mui/material";
import { DashboardContext } from "re_redesigned_componnents/context/Context";
import { math } from "polished";
import { ArrowIcon } from "Icons";
import BasicModal from "re_redesigned_componnents/modal/BasicModal";
import EventDetailModal from "re_redesigned_componnents/modal/EventDetailModal";
import PremiumCourseCard from "re_redesigned_componnents/card/PremiumCourseCard";
import SubscriptionCard from "re_redesigned_componnents/card/SubscriptionCard";
import EventsListModal from "re_redesigned_componnents/modal/EventsListModal";
import { IconAi, IconProgramIcon, IconAssessmentRocket, IconPlayProperty, IconClassroom, IconSubject, IconArrow } from "re_redesigned_componnents/icon";

import { subscribeDirectChat } from "services/chatSocket";

function pickMentorMemberId(ele) {
  if (!ele || typeof ele !== "object") return null;
  const keys = [
    "member_id",
    "trainer_id",
    "trainer_member_id",
    "teacher_member_id",
    "teacher_id",
    "id",
  ];
  for (const k of keys) {
    if (ele[k] != null && ele[k] !== "") {
      const n = Number(ele[k]);
      if (Number.isFinite(n) && n > 0) return n;
    }
  }
  return null;
}

function Dashboard(props) {
  const history = useHistory();
  const { openDirectChat } = useDirectChatModal();
  const isLargeScreen = useMediaQuery('(min-width:767px)');
  const [isLoading, setIsLoading] = useState(true);
  const [directUnread, setDirectUnread] = useState(0);
  const course_route = "/curricula";
  const [teacherDetails, setTeacherDetails] = useState([]);
  const { completion, assesment, ple, open_curriculum } = props.traineeCardData;
  const [myCourse, setMyCourse] = useState([]);
  const [openCourse, setOpenCourse] = useState([]);
  const [notify, setNotify] = useState({ message: null, bell: null });
  const [assessment, setAssessment] = useState([]);
  const [userProgress, setUserProgress] = useState(null);
  const [value, setValue] = useState(null);
  const [open, setOpen] = useState(false);
  const [eventOpen, setEventOpen] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [purchaseSuccess, setPurchaseSuccess] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [startIndex, setStartIndex] = useState(0);
  const [suggestedCourses, setSuggestedCourses] = useState({
    intrested: [],
    jobProfile: [],
  });
  const { toggle, showMenu } = useContext(DashboardContext)
  const userDetails = props.ctx_user.user;
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 60000); // update every minute
    return () => clearInterval(timer);
  }, []);

  // ── Unread chat count (student side) ──────────────────────────────────────
  const organizationId = props.ctx_user.user?.organizationId;

  const loadDirectUnread = useCallback(() => {
    if (!organizationId) return;
    props.ctx_api
      .privateRequest({ cmd: "chat_unread_count", args: { organizationId } })
      .then(({ rsp }) => {
        if (rsp && typeof rsp.count === "number") {
          setDirectUnread(rsp.count);
        }
      })
      .catch(() => { });
  }, [props.ctx_api, organizationId]);

  // Poll every 45 s
  useEffect(() => {
    loadDirectUnread();
    const id = setInterval(loadDirectUnread, 45000);
    return () => clearInterval(id);
  }, [loadDirectUnread]);

  // Refresh immediately on incoming socket message
  useEffect(() => {
    return subscribeDirectChat({ onMessage: loadDirectUnread, onRead: loadDirectUnread });
  }, [loadDirectUnread]);
  // ─────────────────────────────────────────────────────────────────────────

  const formatDateTime = (date) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const dateStr = date.toLocaleDateString(undefined, options);
    const timeStr = date.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${dateStr} | ${timeStr}`;
  };
  const data = {
    labels: ["A", "B", "C", "D", "E"], // X-axis labels
    datasets: [
      {
        label: "Category 1", // Category 1 label
        data: [20], // Values for Category 1
        backgroundColor: "rgba(75, 0, 130, 0.8)", // Color for Category 1
      },
      {
        label: "Category 2", // Category 2 label
        data: [55], // Values for Category 2
        backgroundColor: "rgba(128, 0, 128, 0.8)", // Color for Category 2
      },
      {
        label: "Category 3", // Category 3 label
        data: [30], // Values for Category 3
        backgroundColor: "rgba(216, 191, 216, 0.8)", // Color for Category 3
      },
    ],
  };

  const levelColor = (type) => {
    if (type === "Rookie") {
      return " #FF2121"
    } else if (type === "Beginner") {
      return "#FF8C00"
    } else if (type === "Intermediate") {
      return "#FFFF00"
    } else if (type === "Advanced") {
      return "#00FF15"
    }
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        maxBarThickness: 40, // Max bar width
        barPercentage: 0.5,
        barThickness: 30, // Can control relative width dynamically
        stacked: false,
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
      y: {
        stacked: false,
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };
  const [activity, setActivity] = useState([]);
  const [aiData, setAiData] = useState([
    { title: "AI · Foundations Reactor", tag: "BEGINNER", duration: "4h 0m", level: "Intro", modules: "6 mod", color: "#0066ff", icon: IconAi, amount: "₹ 4,999", image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=1200&auto=format&fit=crop" },
    { title: "AI · Neural Pathways", tag: "CORE", duration: "5h 15m", level: "Intermediate", modules: "7 mod", color: "#0066ff", icon: IconProgramIcon, amount: "₹ 5,499", image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?q=80&w=1200&auto=format&fit=crop" },
    { title: "AI · Signal Synthesis", tag: "ADVANCED", duration: "6h 30m", level: "Advanced", modules: "8 mod", color: "#0066ff", icon: IconAssessmentRocket, amount: "₹ 6,999", image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=400&auto=format&fit=crop" },
    { title: "AI · Hyperloop Patterns", tag: "LAB", duration: "7h 45m", level: "Intro", modules: "9 mod", color: "#0066ff", icon: IconPlayProperty, amount: "₹ 3,999", image: "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=400&auto=format&fit=crop" },
    { title: "AI · Edge Compute Lab", tag: "CAPSTONE", duration: "8h 0m", level: "Intermediate", modules: "10 mod", color: "#0066ff", icon: IconClassroom, amount: "₹ 7,499", image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=400&auto=format&fit=crop" },
    { title: "AI · Holographic UX", tag: "WORKSHOP", duration: "9h 15m", level: "Advanced", modules: "11 mod", color: "#0066ff", icon: IconSubject, amount: "₹ 5,999", image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?q=80&w=400&auto=format&fit=crop" },
    { title: "AI · Quantum Logic", tag: "CORE", duration: "10h 30m", level: "Intermediate", modules: "12 mod", color: "#0066ff", icon: IconAi, amount: "₹ 8,999", image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?q=80&w=400&auto=format&fit=crop" },
    { title: "AI · Neural Mesh", tag: "ADVANCED", duration: "11h 45m", level: "Advanced", modules: "13 mod", color: "#0066ff", icon: IconProgramIcon, amount: "₹ 6,499", image: "https://images.unsplash.com/photo-1507146426996-ef05306b995a?q=80&w=400&auto=format&fit=crop" },
    { title: "AI · Bio-Digital Sync", tag: "BEGINNER", duration: "12h 0m", level: "Intro", modules: "14 mod", color: "#0066ff", icon: IconAssessmentRocket, amount: "₹ 4,499", image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?q=80&w=400&auto=format&fit=crop" },
  ]);
  const getProgress = () => {
    try {
      const value =
        (userProgress.assessment.completed + userProgress.course.completed) /
        (userProgress.assessment.total + userProgress.course.total);
      return Math.round(value * 100);
    } catch (e) {
      console.log("issue in progress", e);
      return 0;
    }
  };
  const totalDuration = () => {
    if (activity?.length > 0) {
      return activity?.reduce((sum, item) => {
        return Math.round(sum + (item.total_duration || 0)); // Add total_duration or 0 if undefined
      }, 0); // Initialize sum to 0
    }
    return 0; // Return 0 if activity is empty or undefined
  };
  useEffect(() => {
    const apiCalls = async () => {
      try {
        const user = props.ctx_user.user;

        const results = await Promise.allSettled([
          fetchDetails("get_dashboard_trainee_course_publishings", {
            memberId: user.id,
            acadYearId: user.acadYearId,
          }),
          fetchDetails("get_new_messages"),
          fetchDetails("get_trainee_home_assessments", {
            acadYearId: user.acadYearId,
          }),
          fetchDetails("get_memberinterest_courses", {
            skills: user.skills,
            memberId: user.id,
          }),
          fetchDetails("get_job_profile_details", {
            role: user.roleId,
            memberId: user.id,
          }),
          fetchDetails("get_trainee_course_progress_dtl", {
            acadYearId: user.acadYearId,
          }),
          fetchDetails("get_trainee_assessment_dtl", {
            acadYearId: user.acadYearId,
          }),
          fetchDetails("get_student_trainer_list", {
            memberId: user.id,
          }),
          fetchDetails("get_trainee_open_courses", {
            acadYearId: user.acadYearId,
          }),
          fetchDetails("get_trainee_studytime", {
            memberId: user.id,
          }),

        ]);

        // Extract results for fulfilled promises
        const [
          courseResult,
          messageResult,
          testResult,
          interestedResult,
          jobProfileResult,
          courseProgress,
          assessmentProgress,
          teacherList,
          openCourses,
          weekly,
        ] = results;

        setMyCourse(courseResult.value || []);
        setNotify((prev) => ({
          ...prev,
          message: messageResult.value?.[0]?.new_message_count || 0,
        }));
        setAssessment(testResult.value || []);

        setSuggestedCourses({
          intrested: interestedResult.value || [],
          jobProfile: jobProfileResult.value || [],
        });
        setValue(courseProgress);

        setUserProgress({
          course: {
            total: courseProgress?.value?.[0]?.totcnt || 0,
            completed: courseProgress.value?.[0]?.completed_status_count,
          },
          assessment: {
            total: assessmentProgress?.value?.[0]?.totcnt || 0,
            completed:
              assessmentProgress?.value[0]?.completed_status_count || 0,
          },
        });

        setTeacherDetails(teacherList.value || []);
        setOpenCourse(openCourses.value || []);
        setActivity(weekly.value || []);
      } catch (e) {
        console.error("error incalls:", e);
      } finally {
        setIsLoading(false);
      }
    };

    apiCalls();
  }, [props.ctx_user.user]);

  const fetchDetails = async (endpoint, arg) => {
    try {
      const rsp = await props.ctx_api.privateRequest({
        cmd: endpoint,
        args: arg,
      });
      console.log("rsp...", rsp);
      return rsp.rsp;
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  const aiCall = async () => {
    try {
      const user = props.ctx_user.user;
      const aiData = await fetchDetails("get_carousal_ai_data", {
        acadYearId: user.acadYearId,
      })
      console.log("aiData...", aiData);
      setOpen(true)
    }
    catch (e) { }

  }
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };
  const mkGreetingMsg = () => {
    const myDate = new Date();
    const hrs = myDate.getHours();

    if (hrs < 12) return props.ctx_labels.singular.goodMorning;
    else if (hrs >= 12 && hrs <= 17)
      return props.ctx_labels.singular.goodAfternoon;
    else if (hrs >= 17 && hrs <= 24)
      return props.ctx_labels.singular.goodEvening;
  };
  const mkGreetingIcon = () => {
    const myDate = new Date();
    const hrs = myDate.getHours();

    if (hrs < 12) return <IconMorning />;
    else if (hrs >= 12 && hrs <= 17) return <IconAfternoon />;
    else if (hrs >= 17 && hrs <= 24) return <IconEvening />;
  };
  const renderCourseCard = (data) => {
    if (data.length > 6) {
      return data.slice(0, 6).map((item, index) => (
        <CourseCard
          key={index} // Use a unique identifier, such as index or item.id
          title={item.name}
          description={item?.description || "No description"}
          image={item?.image || ""}
          click={() => {
            history.push({
              pathname: config.ROUTES.traineeCurriculum, // Replace with your target route
              subjectData: item, // Pass state here
            });
          }}
        />
      ));
    } else {
      return data.map((item, index) => (
        <CourseCard
          key={index} // Use a unique identifier, such as index or item.id
          title={item.name}
          description={item?.description || "No description"}
          click={() => {
            history.push({
              pathname: config.ROUTES.traineeCurriculum, // Replace with your target route
              subjectData: item, // Pass state here
            });
          }}
        />
      ));
    }
  };
  const renderAssessmentCard = (data) => {
    console.log(data, "oo");
    try {
      const maxCards = isLargeScreen ? 4 : 2;
      if (data.length > 4) {
        return data.slice(0, maxCards).map((item, index) => {
          console.log(item, "oo");
          return <AssessmentCard key={index} data={item} />;
        });
      } else {
        return data.map((item, index) => {
          console.log(item, "oo");
          return <AssessmentCard key={index} data={item} />;
        });
      }
    } catch (e) {
      console.log("Error rendering assessment cards:", e);
      return <p>Unable to load assessments.</p>; // Provide fallback UI in case of error
    }
  };
  const shouldShowDrawer = isLargeScreen || toggle;

  if (isLoading) {
    return <DashboardSkeleton showSidebar={isLargeScreen} />;
  }

  return (
    <>
      <EventsListModal open={eventOpen} onClose={() => setEventOpen(false)} />
      {/* <Header/> */}
      <div className={css.wrap}>
        <div className={css.side_wrap}>{/* <SideMenu /> */}</div>
        <div className={css.content_wrap}>
          <div className={css.title_wrap}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <h1 id={css.head_title} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {mkGreetingIcon()}
                {mkGreetingMsg()}, {props.name}
              </h1>
              <span className={css.date_time_display}>
                {formatDateTime(currentDateTime)}
              </span>
            </div>
            <div className={css.infoIcon}>
              <div
                className={css.icon_wrap}
                onClick={() => {
                  history.push("/chat");
                }}
              >
                {/* <Badge
                  badgeContent={notify.message}
                  color="secondary"
                  variant="dot"
                >
                  <IconMail />
                </Badge> */}
              </div>
              <div
                className={css.icon_wrap}
                onClick={() => {
                  history.push("/alert");
                }}
              >
                <Badge badgeContent={4} color="secondary" variant="dot">
                  <IconBell />
                </Badge>
              </div>
              {isLargeScreen && <div
                className={css.icon_wrap}
                onClick={() => {
                  history.push("/profile-settings");
                }}
              >
                {" "}
                <IconSetting />
              </div>}
            </div>
          </div>
          <Carosal ai={aiCall} onEventClick={() => setEventOpen(true)} onLiveClick={() => history.push("/join")} />
          <div className={css.card_wrap}>

            <InfoCard
              color="#650076"
              icon={<IconOpenCourse />}
              title={"My Courses"}
              value={open_curriculum}
            />
            <InfoCard
              color="#990077"
              icon={<IconAssessmentScore />}
              title={"Avg Assmt Score"}
              value={assesment}
            />
            <InfoCard
              color="#CC0177"
              icon={<IconCompletion />}
              title={"Avg Completion Rate"}
              value={`${completion}%`}
            />
            <InfoCard
              color="#4F1382"
              icon={<IconPleCredit />}
              title={"PLE Credits"}
              value={props.ctx_user?.user?.credits || 0}
              button={<ArrowIcon />}
              userDetails={userDetails}
              userProgress={userProgress}
              levelColor={levelColor(userDetails.level)}
            />

          </div>
          <div className={css.course_wrap}>
            <TabWrap
              seeMoreRoute={() => {
                history.push({
                  pathname: course_route,
                });
              }}
              tab={["My Courses "]}
              tabValue={[
                renderCourseCard(myCourse),
                renderCourseCard(openCourse),
              ]}
            />
          </div>
          <div className={css.assessment_wrap}>
            <div className={css.assessment_title}>Assessment Details</div>
            <div className={css.assessment_cardwrap}>
              {renderAssessmentCard(assessment)}
            </div>
            <p
              onClick={() => {
                history.push({
                  pathname: config.ROUTES.assessments,
                });
              }}
              style={{
                paddingBlock: ".8rem",
                color: "blue",
                cursor: "pointer",
                textDecoration: "underline",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                paddingInline: "1rem",
              }}
            >
              See All
            </p>
          </div>
          {/* <div className={css.suggestion_wrap}>
            <TabWrap
              seeMoreRoute={() => {
                history.push({
                  pathname: course_route,
                });
              }}
              tab={[
                "Recemented based on your interest ",
                "Recemented based on your job profile",
              ]}
              tabValue={[
                renderCourseCard(suggestedCourses.intrested),
                renderCourseCard(suggestedCourses.jobProfile),
              ]}
            />
          </div> */}
        </div>
        {shouldShowDrawer && <div className={css.profile_wrap}>
          <div className={css.profile_part}>
            <div className={css.profile_header}>
              profile
              <LogoutButton onLogout={props.onLogout}>
                <IconLogout />
              </LogoutButton>
            </div>
            <CircularProgressBar
              progress={userProgress && getProgress()}
              size={108}
              strokeWidth={10}
            >
              <img
                id={css.profile_pic}
                src={props.ctx_user.user.photo}
                alt=""
                onClick={() => {
                  history.push("/profile-settings");
                }}
              />
            </CircularProgressBar>
            <h1 className={css.profile_header} id={css.name}>
              {props.ctx_user?.user?.firstName}
            </h1>
            <div className={css.class_wrap}>
              {" "}
              <p className={css.class_tag}>{userDetails.className}</p>
              <Chip
                label={userDetails.level}
                sx={{
                  backgroundColor: levelColor(userDetails.level),
                  color: "white",
                  height: "25px",
                }}
              />
            </div>

          </div>
          <div className={css.profile_detail}>
            <h1 className={css.profile_header}>Weekly Activity</h1>
            <div className={css.chart}>
              <div className={css.chart_title}>
                <p>This week</p>
                <span>
                  <h1>{totalDuration()}</h1>
                  <p>hrs</p>
                </span>

              </div>
              <AreaChart data={activity} />
            </div>
            <h1 className={css.profile_header}>My Mentors/Teachers</h1>
            <div className={css.teacher_list}>
              {teacherDetails.map((ele, index) => {
                const mentorId = pickMentorMemberId(ele);
                return (
                  <div className={css.user_card_wrap} key={index}>
                    <Avatar alt={ele.name} src={ele.photo} />
                    <div className={css.user_details}>
                      <h1 className={css.user_name}>{ele.name}</h1>
                      <h1 className={css.user_email}>{ele.email}</h1>
                    </div>
                    {mentorId ? (
                      <Tooltip title="Chat">
                        <IconButton
                          size="small"
                          onClick={() => {
                            // Optimistically clear the badge the moment the student opens chat
                            setDirectUnread(0);
                            openDirectChat({ peerMemberId: mentorId });
                          }}
                          aria-label="Chat with mentor"
                        >
                          <Badge
                            badgeContent={directUnread}
                            color="error"
                            max={99}
                            invisible={directUnread === 0}
                          >
                            <ChatBubbleOutlineIcon fontSize="small" />
                          </Badge>
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>}
      </div>
      <BasicModal open={open} onChange={setOpen} >
        <div className={css.carosalPop}>
          <div className={css.modal_header_no_title}>
             <button className={css.close_btn} onClick={()=>{setOpen(false)}}>×</button>
          </div>
          
          <div className={css.slider_container}>
            <button 
              className={`${css.arrow_btn} ${css.prev}`} 
              onClick={() => setStartIndex(Math.max(0, startIndex - 1))}
              disabled={startIndex === 0}
            >
              <ArrowIcon />
            </button>

            <div className={css.subscription_grid}>
              {aiData?.slice(startIndex, startIndex + 3).map((item, index) => {
                const isCenter = index === 1;
                return (
                  <SubscriptionCard 
                    key={startIndex + index}
                    title={item.tag}
                    price={item.amount}
                    description={item.title}
                    image={item.image}
                    features={[
                      "100+ prompt templates",
                      `${item.modules} content`,
                      "24/7 priority support"
                    ]}
                    isHighlighted={isCenter}
                    icon={item.icon}
                    color={item.color}
                    onClick={() => {
                      setSelectedCourse(item);
                      setPaymentOpen(true);
                    }}
                  />
                );
              })}
            </div>

            <button 
              className={`${css.arrow_btn} ${css.next}`} 
              onClick={() => setStartIndex(Math.min(aiData.length - 3, startIndex + 1))}
              disabled={startIndex >= aiData.length - 3}
            >
              <ArrowIcon />
            </button>
          </div>
        </div>
      </BasicModal>
      <BasicModal open={paymentOpen} onChange={(val) => {
        setPaymentOpen(val);
        if (!val) setPurchaseSuccess(false);
      }}>
        <div className={css.payment_popup}>
          <div className={css.modal_header}>
            <h2>{purchaseSuccess ? "Success!" : "Checkout"}</h2>
            <button className={css.close_btn} onClick={() => {
              setPaymentOpen(false);
              setPurchaseSuccess(false);
            }}>×</button>
          </div>
          
          <div className={css.payment_content}>
            {purchaseSuccess ? (
              <div className={css.success_view}>
                <div className={css.success_icon}>✓</div>
                <h3>Payment Successful!</h3>
                <p>Thank you for purchasing <strong>{selectedCourse?.title}</strong>.</p>
                <p>You are being redirected to your courses...</p>
                <button 
                  className={css.buy_btn} 
                  onClick={() => {
                    setPaymentOpen(false);
                    setPurchaseSuccess(false);
                    setOpen(false);
                    history.push("/curricula");
                  }}
                >
                  Go to Courses
                </button>
              </div>
            ) : (
              <>
                <div className={css.course_info}>
                  <h3>{selectedCourse?.title}</h3>
                  <p className={css.price}>{selectedCourse?.amount}</p>
                </div>

                <div className={css.payment_methods}>
                  <h4>Select Payment Method</h4>
                  <div className={css.method_list}>
                    <div className={css.method_item}>
                      <input type="radio" id="upi" name="payment" defaultChecked />
                      <label htmlFor="upi">UPI (GPay, PhonePe, Paytm)</label>
                    </div>
                    <div className={css.method_item}>
                      <input type="radio" id="card" name="payment" />
                      <label htmlFor="card">Credit / Debit Card</label>
                    </div>
                    <div className={css.method_item}>
                      <input type="radio" id="netbanking" name="payment" />
                      <label htmlFor="netbanking">Net Banking</label>
                    </div>
                  </div>
                </div>

                <button 
                  className={css.buy_btn} 
                  onClick={() => {
                    setPurchaseSuccess(true);
                    setTimeout(() => {
                      setPaymentOpen(false);
                      setPurchaseSuccess(false);
                      setOpen(false);
                      history.push("/curricula");
                    }, 3000);
                  }}
                >
                  Buy Now
                </button>
              </>
            )}
          </div>
        </div>
      </BasicModal>
      <EventDetailModal open={eventOpen} onClose={() => setEventOpen(false)} />
    </>
  );
}
export default withLabelsContext(withApiContext(withUserContext(Dashboard)));
